/**
 * @file serviceDiagnosisService.js
 * @description Service → Diagnosis API (server controllers/serviceDiagnosisController.js).
 */
import apiClient from './apiClient';

const enc = encodeURIComponent;

const serviceDiagnosisService = {
    /** The fleet to pick from, with the open fault-code / threshold counts of each. */
    async listMachines() {
        return apiClient.get('/service/diagnosis/machines');
    },

    /** One machine: now, check sheet (level A–H optional), since last service, parts. */
    async get(equipmentId, level) {
        return apiClient.get(`/service/diagnosis/${enc(equipmentId)}${level ? `?level=${enc(level)}` : ''}`);
    },

    /** Mark a check item OK / NOT_OK (null clears it), with an optional note. */
    async saveCheck(equipmentId, itemCode, { status, note }) {
        return apiClient.put(`/service/diagnosis/${enc(equipmentId)}/checks/${enc(itemCode)}`, { status, note });
    },

    /** Record a part changed on the machine. */
    async addPart(equipmentId, part) {
        return apiClient.post(`/service/diagnosis/${enc(equipmentId)}/parts`, part);
    },
};

export default serviceDiagnosisService;
